import React from 'react'
import { Box, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: '1px solid #70707033',
    display: 'flex',
    width: '100%',
    //alignItems: 'center',
  },
  toggleLabel: {
    fontSize: '20px',
    color: '#545456',
    opacity: '50%',
    fontWeight: '600',
    margin: '0px 15px',
    cursor: 'pointer',
  },
  selected: {
    color: '#335977',
    opacity: '100%',
  },
  highlight: {
    height: '8px',
    width: '90%',
    background: '#F37320',
    border: '1px solid #F37320',
    borderRadius: '100px',
    marginTop: '10px',
    position: 'relative',
    top: '5px',
  },
  wrapper: {
    // width: '142px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
    minHeight: '43px',
  },
}))

function Toggle(props) {
  const classes = useStyles()
  const { list, onChange } = props

  const renderListView = (obj) => {
    return (
      <Box className={classes.wrapper}>
        <Box className={`${classes.toggleLabel} ${obj.id === props.selected ? classes.selected : ''}`}
          onClick={() => onChange(obj.id)}
        >
          {obj.label}
        </Box>
        <Typography
          className={
            obj.id === props.selected
              ? classes.highlight
              : classes.highlightWrapper
          }
        ></Typography>
      </Box>
    )
  }

  return <Box className={classes.root}>{list.map(renderListView)}</Box>
}

Toggle.defaultProps = {
  list: [],
  onChange: () => { },
}

export default Toggle
